<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import RequestedForPayment from "@/components/widgets/requested-for-payment";
import PrintOptions from "@/components/modals/print-options.vue";
import CreateRfpModal from "@/components/modals/create-rfp-modal.vue";

export default {
    page: {
        title: "Request for Disbursement",
    },
    components: {
        Layout,
        PageHeader,
        RequestedForPayment,
        PrintOptions,
        CreateRfpModal,
    },
    data() {
        return {
            title: "Request for Disbursement",
            items: [
                {
                    text: "Dashboard",
                    href: "/",
                },
                {
                    text: "Request for Disbursement",
                    active: true,
                },
            ],
            available: [],
            posted: [],
            pending: [],
            cycle: null,
        };
    },
    methods: {
        changeCycle(cycle) {
            this.fetchList(cycle, this.$store.state.data.selectedDU.id);
        },
        async fetchList(cycle, deliveryUnitId) {
            try{
                const { data: posted } = await this.$store.dispatch("rfppayment/getDUPosted", { deliveryUnitId: deliveryUnitId, cycle: cycle });
                if(posted.error){
                    this.showToast(posted.errorMessage, 'error')
                    return;
                }
                this.posted = posted;
            }catch(error){
                this.showToast('Something went wrong - getting posted funds', 'error')
            }
            try{
                const { data: pending } = await this.$store.dispatch("rfppayment/getDUPending", {   deliveryUnitId: deliveryUnitId, cycle: cycle });
                if(pending.error){
                    this.showToast(pending.errorMessage, 'error')
                    return;
                }
                this.pending = pending;
            }catch(error){
                this.showToast('Something went wrong - getting posted pending', 'error')
            }
        },
        async submitRFP(modalData){
            modalData.deliveryUnitId = this.$store.state.data.selectedDU.id;
            modalData.cycle = this.$store.state.data.cycle;
            if(modalData.id > 0){
                this.$store
                    .dispatch("rfppayment/updatePayment", modalData)
                    .then((res) => {
                        if (res.data.error) {
                            return this.showToast(res.data.errorMessage, "error");
                        }
                        let index = this.pending.findIndex(
                            (item) => item.id == res.data.id
                        );
                        this.pending.splice(index, 1, modalData);
                        this.$bvModal.hide("create-rfp-modal");
                        this.showToast("Successfully updated!", "success");
                    })
                    .catch((err) => {
                        this.showToast("Something went wrong!", "error");
                    });
            }else{
                this.$store
                    .dispatch("rfppayment/createPayment", modalData)
                    .then((res) => {
                        if (res.data.error) {
                            return this.showToast(res.data.errorMessage, "error");
                        }
                        this.pending.push(res.data);
                        this.$bvModal.hide("create-rfp-modal");
                        this.showToast("Successfully created!", "success");
                    })
                    .catch((err) => {
                        this.showToast("Something went wrong!", "error");
                    });
            }
        },
        async updateAvailable(record) {
            if (record.action === "add") {
                let index = this.available.findIndex(
                    (item) => item.id == record.deliveryUnitBudgetItemId
                );
                this.available[index].available = record.balance;
                if (record.isPosted) {
                    this.posted.push(record.response);
                } else {
                    this.pending.push(record.response);
                }
            }
            if (record.action === "delete") {
                this.available.find(
                    (item) => item.id == record.data.deliveryUnitBudgetItemId
                ).available += record.data.amount;
                let index = this.pending.findIndex(
                    (item) => item.id == record.data.id
                );
                this.pending.splice(index, 1);
            }
            if (record.action === "update") {
                let index = this.available.findIndex(
                    (item) => item.id == record.deliveryUnitBudgetItemId
                );
                this.available[index].available = record.balance;
                let pendingIndex = this.pending.findIndex(
                    (item) => item.id == record.response.id
                );
                this.pending.splice(pendingIndex, 1, record.response);
            }
        },
        postPayment(record) {
            this.$swal({
                title: "Are you sure?",
                text:
                "Are you sure you want to post this collection? You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#00cfe8",
                confirmButtonText: "Yes, post it!",
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$store
                        .dispatch("rfppayment/postPayment", record.id)
                        .then((res) => {
                            if (res.data.error) {
                                return this.showToast(res.data.errorMessage, "error");
                            }
                            let index = this.pending.findIndex(
                                (item) => item.id == record.id
                            );
                            this.pending.splice(index, 1);
                            this.posted.push(record);
                            this.$bvModal.hide("create-rfp-modal");
                            this.showToast("Successfully posted!", "success");
                        })
                        .catch((err) => {
                            this.showToast("Something went wrong!", "error");
                        });
                }
            });
        },
        pushToPost(record) {
            this.posted.push(record);
        },
        printRFP(id) {
            this.$refs.printOpt.putOptions({
                apiUrl: "api/Report/Finance/RFP",
                routeVariables: [id],
            });
            this.$bvModal.show("print-options-modal");
        },
        createRFP() {
            this.$refs.createRfpModal.onReset();
            this.$bvModal.show("create-rfp-modal");
        },
        changeDU(deliveryUnitId) {
            this.fetchList(this.$store.state.data.cycle, deliveryUnitId);
            this.$refs.createRfpModal.getAllBudgets();
        },
        editRFP(record) {
            this.$refs.createRfpModal.updateData(record);
            this.$bvModal.show("create-rfp-modal");
        },
        deleteRFP(record) {
            this.$swal({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, delete it!",
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$store
                        .dispatch("rfppayment/deletePayment", record.id)
                        .then((res) => {
                            if (res.data.error) {
                                return this.showToast(res.data.errorMessage, "error");
                            }
                            let index = this.pending.findIndex((item) => item.id == record.id);
                            this.pending.splice(index, 1);
                            this.$bvModal.hide("create-rfp-modal");
                            this.showToast("Successfully deleted!", "success");
                        })
                        .catch((err) => {
                            this.showToast("Something went wrong!", "error");
                        });
                }
            });
        },
    },
    async created() {
        await this.fetchList(this.$store.state.data.cycle, this.$store.state.data.selectedDU.id);
    },
};
</script>

<template>
    <Layout @changeCycle="changeCycle" @changeDU="changeDU($event.id)">
        <PageHeader :title="title" :items="items" />
        <b-tabs content-class="pt-3 pb-3 text-muted">
            <b-tab>
                <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                        <i class="bx bx-home"></i>
                    </span>
                    <span class="d-none d-sm-inline-block">Pending</span>
                </template>
                <RequestedForPayment
                    type="pending"
                    :records="pending"
                    @edit-item="editRFP"
                    @delete-item="deleteRFP"
                    @create-rfp="createRFP"
                    @post-payment="postPayment"
                    @print-rfp="printRFP"
                />
            </b-tab>
            <b-tab>
                <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                        <i class="bx bx-home"></i>
                    </span>
                    <span class="d-none d-sm-inline-block">Posted</span>
                </template>
                <RequestedForPayment 
                    type="posted" 
                    :records="posted" 
                    @print-rfp="printRFP" 
                />
            </b-tab>
        </b-tabs>
        <print-options ref="printOpt"></print-options>
        <create-rfp-modal 
            ref="createRfpModal"
            @createRfp="submitRFP"
            modal-title="Create New RFP"
        />
    </Layout>
</template>
